<template>

    <dx-data-grid
        style="flex-grow: 1"
        :data-source="dataSource"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :show-column-lines="true"
        :show-borders="true"
        :height="50"
        :width="'100%'"
        :column-min-width="50"
        :word-wrap-enabled="true"
        @toolbar-preparing="onToolbarPreparing($event)"
    >
        <dx-group-panel :visible="true" />
        <dx-grouping :auto-expand-all="false" :contextMenuEnabled="true" />
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-export :enabled="true" :formats="['pdf', 'excel']" :allow-export-selected-data="true" />

        <dx-column
            caption="id"
            data-field="id"
            data-type="number"
            :width="100"
        />

        <template #demoTemplate1>
            demoTemplate1
        </template>

        <template #demoTemplate2>
            demoTemplate2
        </template>

        <template #demoTemplate3>
            demoTemplate3
        </template>
    </dx-data-grid>

    <footer-grid :totalCount="totalCount"></footer-grid>

</template>

<script>
export default {
    name: 'ai-toolbar-demo'
};
</script>

<script setup>
import { ref, onBeforeMount } from 'vue';
import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxLoadPanel,
    DxSorting,
    DxExport,
    DxGrouping,
    DxGroupPanel
} from 'devextreme-vue/data-grid'

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';

const
    totalCount = ref(0),
    dataSource = ref([]);
let
    gridButtons = {};

onBeforeMount(async () => {
    await reloadData();
});

const reloadData = async () => {
    dataSource.value = [{id: 1}, {id: 2}];
    totalCount.value = dataSource.value?.length || 0;
}

const onToolbarPreparing = (e) => {
    gridButtons = getAiToolbar(e, {
        customs: [
            {
                name: `aiCustomButton1`,
                location: 'after',
                widget: 'dxButton',
                locateInMenu: 'auto',
                showText: 'inMenu',
                after: 'refresh',
                options: {
                    icon: 'home',
                    hint: 'Кастомная кнопка 1',
                    text: 'Кастомная кнопка 1',
                    onClick: () => {
                        console.log('aiCustomButton1');
                    },
                },
            }, {
                name: `aiCustomButton2`,
                location: 'after',
                widget: 'dxButton',
                locateInMenu: 'auto',
                showText: 'inMenu',
                before: 'save',
                options: {
                    icon: 'user',
                    hint: 'Кастомная кнопка 2',
                    text: 'Кастомная кнопка 2',
                    onClick: () => {
                        console.log('aiCustomButton2');
                    },
                },
            },
            {
                location: 'before',
                template: 'demoTemplate1',
            }, {
                location: 'after',
                template: 'demoTemplate2',
                before: 'add',
            }, {
                location: 'after',
                template: 'demoTemplate3',
                after: 'save',
            }],
        expand: {
            event: (e) => {
                console.log('expand', e);
            },
        },
        refresh: {
            event: async (e) => {
                await reloadData();
            },
        },
        add: {
            event: (e) => {
                if (gridButtons.save) {
                    gridButtons.save.option({
                        disabled: false
                    });
                }
                console.log('add', e);
            },
        },
        copy: {
            event: (e) => {
                console.log('copy', e);
            },
        },
        delete: {
            event: (e) => {
                console.log('delete', e);
            },
        },
        save: {
            event: (e) => {
                console.log('save', e);
            },
        },
        addRoot: {
            event: (e) => {
                console.log('addRoot', e);
            },
        },
        addChild: {
            event: (e) => {
                console.log('addChild', e);
            },
        },

    });
}

</script>

<style lang="scss" scoped>

</style>
